var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-map ml-4 mr-4" },
    [
      _vm.type === "create"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row py-3 align-items-center" }, [
                _c("div", { staticClass: "col company-h1" }, [
                  _c("button", {
                    staticClass: "btn btn-back",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("companies-info")
                      }
                    }
                  }),
                  _vm._v("\n        Create Company\n      ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ld-ext-right",
                      class: _vm.loadingButton ? "running" : "",
                      attrs: { type: "button", disabled: _vm.buttonDisabled }
                    },
                    [
                      _vm._v("\n          Save\n          "),
                      _c("div", { staticClass: "ld ld-ball ld-flip" })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("companies-steps-menu", { attrs: { type: "create" } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "edit"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row py-3 align-items-center company-header" },
              [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("h2", { staticClass: "company-h1 mr-3" }, [
                      _c("button", {
                        staticClass: "btn btn-back",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/companies")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.company.name) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.company.status
                      ? [
                          _vm.company.status.name === "Active"
                            ? _c("span", { class: "btn-status btn-active" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Inactive"
                            ? _c("span", { class: "btn-status btn-closed" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Setup Incomplete"
                            ? _c(
                                "span",
                                { class: "btn-status btn-ncover info-company" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.company.status.name) +
                                      "\n            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btn btn-link p-0 tippy-popup tippy-info",
                                      on: {
                                        mouseover: function($event) {
                                          _vm.showTooltipPrefix = true
                                        },
                                        mouseout: function($event) {
                                          _vm.showTooltipPrefix = false
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTooltipPrefix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "popover tippy-info-popover"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-8 d-flex align-items-center justify-content-end"
                  },
                  [
                    _vm.$_can("companies.review.request")
                      ? _c("companies-visibility-bar", {
                          attrs: { company: _vm.company },
                          on: {
                            saved: function($event) {
                              _vm.$emit("saved")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right ml-5",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled }
                      },
                      [
                        _vm._v("\n          Save\n          "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mb-3 w-100" }, [
        _c("h5", { staticClass: "companies-sub-page-title" }, [
          _vm._v("Billing info")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "description-text" }, [
          _vm._v(
            "You can enter your billing details on this page. This is how you will receiving earnings made from bookings on Mod24 website. You can opt to setup your bill.com or receive checks."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payout-wrapper" }, [
          _c("div", { staticClass: "payout-status" }, [
            _c("h5", { staticClass: "payout-title" }, [
              _vm._v("Your next payout date will be determined after approval.")
            ]),
            _vm._v(" "),
            !_vm.company.company_billing
              ? _c("button", { staticClass: "btn btn-not-have-billing mt-3" }, [
                  _vm._v("You don't have any billing details saved.")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "payout-buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    _vm.showBillingModal = true
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.company.company_billing &&
                    _vm.company.company_billing.id
                      ? "Edit"
                      : "Add"
                  ) + " Billing Details"
                )
              ]
            ),
            _vm._v(" "),
            _c("button", { staticClass: "btn", attrs: { disabled: "" } }, [
              _vm._v("View Payments History")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex mt-3 align-items-center justify-content-between section-wrapper"
          },
          [
            _c("div", { staticClass: "tier" }, [
              _c("h2", { staticClass: "l-header-2" }, [_vm._v("Tier level")]),
              _vm._v(" "),
              _vm.company.mod_tier
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between"
                    },
                    [
                      _c("h5", { staticClass: "tier-title m-0" }, [
                        _vm._v(_vm._s(_vm.company.mod_tier.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "tier-properties ml-5" },
                        _vm._l(_vm.company.mod_tier.mod_tier_options, function(
                          tierOption
                        ) {
                          return _c("li", { key: tierOption.id }, [
                            _vm._v(_vm._s(tierOption.name))
                          ])
                        })
                      )
                    ]
                  )
                : _c("div", { staticClass: "no-tier p-3" }, [
                    _vm._v("\n          Company doesn't have tier.\n        ")
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tier-buttons" }, [
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      _vm.setCompanyStep("companies-tier")
                    }
                  }
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn",
                      attrs: {
                        to:
                          "/companies/edit/" +
                          _vm.$route.params.id +
                          "?tab=companies-tier"
                      }
                    },
                    [_vm._v("Change Tier level")]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex mt-3  flex-column section-wrapper" }, [
          _c("h2", { staticClass: "l-header-2" }, [
            _vm._v("Your company details")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-1" }, [
            _vm._v("\n        Company details for "),
            _c("b", [_vm._v(_vm._s(_vm.dateFrom))]),
            _vm._v(" - "),
            _c("b", [_vm._v(_vm._s(_vm.dateTo))])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0)" },
                on: { click: _vm.togglePreviousOrCurrentMonth }
              },
              [
                _vm._v("Show "),
                _vm.currentMonth ? [_vm._v("previous")] : [_vm._v("current")],
                _vm._v(" month")
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.companyEarningInfo
            ? _c("table", { staticClass: "company-info-table mt-3" }, [
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_vm._v("Website bookings")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.companyEarningInfo.booked_jobs))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Completed jobs")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.companyEarningInfo.completed_jobs))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Total earned")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "amount" }, [
                      _vm._v("$" + _vm._s(_vm.companyEarningInfo.total_earned))
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showBillingModal
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showBillingModal = false
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "filters-side-modal flex flex-column justify-content-start"
                  },
                  [
                    _vm.showSearchComponent
                      ? [
                          _vm.showSearchComponent
                            ? _c("vendor-search-results", {
                                attrs: { "search-results": _vm.searchResults },
                                on: {
                                  back: _vm.hideSearchComponent,
                                  cancel: _vm.resetModal,
                                  saved: _vm.saved
                                }
                              })
                            : _vm._e()
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "pointer",
                              on: {
                                click: function($event) {
                                  _vm.showBillingModal = !_vm.showBillingModal
                                }
                              }
                            },
                            [
                              _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                                _c("span", { staticClass: "btn btn-back" }),
                                _vm._v("Billing Details")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("p", [
                              _vm._v(
                                "\n              We are using Bill.com for transfer funds from one organization to another.\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n              Use the search to find your account and we'll send you and invite to connect with Mod24. Or select the option to receive payouts via check.\n            "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "l-bg-white" }, [
                            _c(
                              "span",
                              { staticClass: "add-billing-select-text" },
                              [
                                _vm._v(
                                  "How would you like to receive payments?"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "add-billing-options mt-3 mx-3" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "billing-option",
                                    class: {
                                      "billing-option-selected":
                                        _vm.typeSelected === "check"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.typeSelected = "check"
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "billing-details d-flex align-items-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "mod-icon-billing-check mr-1"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "billing-option-info"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "billing-option-title"
                                              },
                                              [_vm._v("Check payout")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "billing-option-description"
                                              },
                                              [
                                                _vm._v(
                                                  "Select to receive payments as checks"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.typeSelected === "check"
                                      ? _c("span", {
                                          staticClass:
                                            "mod-icon-billing-option-checked"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "add-billing-options mt-3 mx-3" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "billing-option",
                                    class: {
                                      "billing-option-selected":
                                        _vm.typeSelected === "bill.com"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.typeSelected = "bill.com"
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "billing-details d-flex align-items-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "mod-icon-bill mr-1"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "billing-option-info"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "billing-option-title"
                                              },
                                              [_vm._v("Bill.com")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "billing-option-description"
                                              },
                                              [
                                                _vm._v(
                                                  "Find your account by using network search or create account"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.typeSelected === "bill.com"
                                      ? _c("span", {
                                          staticClass:
                                            "mod-icon-billing-option-checked"
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mt-5" },
                              [
                                _vm.typeSelected === "check"
                                  ? _c("check", {
                                      attrs: { company: _vm.company },
                                      on: {
                                        cancel: function($event) {
                                          _vm.showBillingModal = false
                                        },
                                        saved: _vm.saved
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.typeSelected === "bill.com"
                                  ? _c("vendor-search", {
                                      on: {
                                        cancel: function($event) {
                                          _vm.showBillingModal = false
                                        },
                                        searchCompleted: _vm.showSearchResults
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]
                  ],
                  2
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7781bcfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7781bcfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/mod24settings/CompaniesBillingInfo.vue
// module id = null
// module chunks = 